import {
    VIDEO_MUTATOR_LOAD_SELECTED,
    VIDEO_MUTATOR_RESET,
    VIDEO_MUTATOR_SET_BUILDING_PK,
    VIDEO_MUTATOR_SET_CLIENT_PK,
    VIDEO_MUTATOR_SET_PROPERTY_PK,
    VIDEO_MUTATOR_SET_THUMBNAIL,
    VIDEO_MUTATOR_SET_TITLE,
    VIDEO_MUTATOR_SET_TRANSLATION_REQUESTS,
    VIDEO_MUTATOR_SET_UPLOAD_PROGRESS,
    VIDEO_MUTATOR_SET_VIDEO,
    VIDEO_MUTATOR_SET_VIDEO_FRAME,
    VIDEO_MUTATOR_SET_VIDEO_FRAME_CONTEXT,
    VIDEO_MUTATOR_SET_VIDEO_PREVIEW,
} from '../actionTypes'

const defaultState = {
    buildingPk: undefined,
    clientPk: undefined,
    fileList: null,
    progress: 0,
    propertyPk: undefined,
    thumbnail: null,
    title: {
        text: [{ language: 'ENGLISH', text: '' }],
        valid: false,
    },
    translationRequests: null,
    type: null,
    uploading: false,
    video: null,
    videoFrame: null,
    videoFrameContext: null,
    videoPreview: null,
}

const videoMutatorReducer = (state = defaultState, action) => {
    switch (action.type) {
        case VIDEO_MUTATOR_LOAD_SELECTED:
            const d1 = action.selectedVideo.d1.split('#')
            return {
                ...state,
                buildingPk: d1[4],
                clientPk: d1[1],
                propertyPk: d1[3],
                title: {
                    text: action.selectedVideo.meta.title,
                    valid: true,
                },
            }

        case VIDEO_MUTATOR_RESET:
            return defaultState

        case VIDEO_MUTATOR_SET_BUILDING_PK:
            return {
                ...state,
                buildingPk: action.buildingPk,
            }

        case VIDEO_MUTATOR_SET_CLIENT_PK:
            return {
                ...state,
                clientPk: action.clientPk,
            }

        case VIDEO_MUTATOR_SET_PROPERTY_PK:
            return {
                ...state,
                propertyPk: action.propertyPk,
            }

        case VIDEO_MUTATOR_SET_THUMBNAIL:
            return {
                ...state,
                thumbnail: action.thumbnail,
            }

        case VIDEO_MUTATOR_SET_TITLE:
            return {
                ...state,
                title: action.title,
            }

        case VIDEO_MUTATOR_SET_TRANSLATION_REQUESTS:
            return {
                ...state,
                translationRequests: action.translationRequests,
            }

        case VIDEO_MUTATOR_SET_UPLOAD_PROGRESS:
            return {
                ...state,
                progress: action.progress,
            }

        case VIDEO_MUTATOR_SET_VIDEO:
            return {
                ...state,
                video: action.video,
            }

        case VIDEO_MUTATOR_SET_VIDEO_FRAME:
            return {
                ...state,
                videoFrame: action.videoFrame,
            }

        case VIDEO_MUTATOR_SET_VIDEO_FRAME_CONTEXT:
            return {
                ...state,
                videoFrameContext: action.videoFrameContext,
            }

        case VIDEO_MUTATOR_SET_VIDEO_PREVIEW:
            return {
                ...state,
                videoPreview: action.videoPreview,
            }

        default:
            return state
    }
}

export default videoMutatorReducer
